import { createIcon } from "@chakra-ui/react";

export default createIcon({
  displayName: "Landslides",
  viewBox: "0 0 50 50",
  path: (
    <path
      d="M30.512 40.046 14.058 21.53 0 12.987V50h47.104l-16.591-9.954Zm9.071-10.88-4.166 6.25 4.166 4.167L43.75 37.5l2.083-6.25-6.25-2.084ZM22.917 12.5l-4.167 4.166 2.083 6.25L27.083 25l4.167-4.167-2.083-6.25-6.25-2.083Zm6.25 20.833-2.084-2.083 2.084-4.167 4.166 4.167-4.166 2.083ZM12.5 6.25l2.083 4.166v4.167h-4.166L6.25 10.416l4.167-4.166H12.5Zm8.333-2.083L18.75 6.25l4.167 2.083V4.166h-2.084Z"
      fill="currentColor"
    />
  ),
});
